import { createElement } from 'react'
import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator } from '../cell-validators'
import { getShipmentDisplayCalculated } from '../entities/shipment/get-shipment-display-calculated'

const markupBelowRecommended = (costOfAllCopies: number, marginRatio: number): boolean => {
    if (costOfAllCopies > 16000 && costOfAllCopies <= 30000 && marginRatio < 2.3) return true
    if (costOfAllCopies > 30000 && costOfAllCopies <= 50000 && marginRatio < 2.2) return true
    if (costOfAllCopies > 50000 && costOfAllCopies <= 100000 && marginRatio < 2.1) return true
    if (costOfAllCopies > 100000 && costOfAllCopies <= 170000 && marginRatio < 2.0) return true
    if (costOfAllCopies > 170000 && costOfAllCopies <= 250000 && marginRatio < 1.9) return true
    if (costOfAllCopies > 250000 && marginRatio < 1.8) return true
    return false
}

const validationMessageList = (messages: string[]) =>
    messages.length === 1
        ? messages[0]
        : createElement(
              'ul',
              { style: { margin: 0, paddingLeft: 16 } },
              messages.map((m, i) => createElement('li', { key: i }, m)),
          )

export const validateProfitOfAllCopies: CellValidator = (record, token: GlobalToken) => {
    const calculated = getShipmentDisplayCalculated(record)
    const costOfAllCopies = calculated?.costOfAllCopies
    const marginRatio = calculated?.marginRatio
    const profitOfAllCopies = calculated?.profitOfAllCopies
    const paintCost = calculated?.paintCost
    const profitPerHour = calculated?.profitPerHour

    if (
        costOfAllCopies === undefined ||
        marginRatio === undefined ||
        profitOfAllCopies === undefined ||
        paintCost === undefined ||
        profitPerHour === undefined
    ) {
        return null
    }

    const messages: string[] = []
    let paintIssue = false
    let marginIssue = false
    let markupWarning = false
    let hasCostProfitError = false
    let hasPphError = false
    let hasPphWarning = false

    if (profitOfAllCopies < paintCost) {
        messages.push('Прибыль с тиража меньше стоимости краски')
        paintIssue = true
    }
    if (marginRatio < 1.45) {
        messages.push('Коэффициент наценки меньше 1.45')
        marginIssue = true
    }
    if (costOfAllCopies <= 16000 && profitOfAllCopies < 20000) {
        messages.push('Себестоимость 16к и меньше, прибыль менее 20к')
        hasCostProfitError = true
    }

    if (profitPerHour < 15000) {
        messages.push('Прибыль в час менее 15 000')
        hasPphError = true
    } else if (profitPerHour < 30000) {
        messages.push('Прибыль в час от 15 000 до 30 000')
        hasPphWarning = true
    } else {
        messages.push('Прибыль в час 30 000 и более')
    }

    if (markupBelowRecommended(costOfAllCopies, marginRatio)) {
        messages.push('Наценка ниже рекомендуемой для данной себестоимости')
        markupWarning = true
    }

    const hasError = paintIssue || marginIssue || hasCostProfitError || hasPphError
    const hasWarning = hasPphWarning || markupWarning

    const color = hasError
        ? token.colorErrorText || token.colorError
        : hasWarning
          ? token.colorWarningText || token.colorWarning
          : token.colorSuccessText || token.colorSuccess

    const bgColor =
        paintIssue
            ? token.colorErrorBg
            : marginIssue || markupWarning
              ? ''
              : undefined

    return {
        message: validationMessageList(messages),
        color,
        ...(bgColor !== undefined ? { bgColor } : {}),
    }
}
